import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Header from 'components/headers/addLoan'
import HandIcon from 'assets/images/easyPay/init.svg'
import useSetInitPayment from './hooks/useSetInitPayment'
import DotsLoading from 'components/loadings/dotsLoading'
import style from './payForOther.module.scss'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import AddJustPayForOtherModal from 'components/modals/addJustPayForOthers'
import EditIcon from 'assets/images/loans/edit.svg'
import useGetInitPaymentOs from 'pages/wallet/hooks/useGetInitPaymentOs'
import { NumericFormat } from 'react-number-format'
import Switch from 'react-switch'
import useSetTransactionsWallet from './hooks/useSetTransactionsWallet'
import useGetMoneyPoolCashin from './hooks/useGetMoneyPoolCashin'
import {
    ISelectedBank,
    useIsDefaultGateway,
} from 'utilities/hooks/useIsDefaultGateway'

export default function PayForOther() {
    const { state } = useLocation()
    const { data, isLoading } = useSetInitPayment(
        Number(state?.item?.id),
        Number(state?.item?.unpaid_portion)
    )
    const [lackOfWallet, setLackOfWallet] = useState<number>(0)
    const [isWallet, setIsWallet] = useState<boolean>(false)
    const [payment, setPayment] = useState<number>(0)
    useEffect(() => {
        if (data) {
            setPayment(Number(state?.item?.unpaid_portion))
        }
    }, [data])
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { moneyPool } = useParams()

    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data: walletData } = useGetInitPaymentOs(
        profile?.id,
        Number(data?.commission),
        Number(payment)
    )

    const [jsonData, setJsonData] = useState<any>([])
    const [isSelected, setIsSelected] = useState<ISelectedBank>({
        saderat: false,
        parsian: false,
    })

    useIsDefaultGateway(data, setIsSelected)
    console.log('state: ', state)

    useEffect(() => {
        if (payment && moneyPool && data && state) {
            setJsonData([
                {
                    moneyPool: Number(moneyPool),
                    amount: Number(payment) + Number(data.commission),
                    ctxId: Number(moneyPool),
                    gateway: isSelected.saderat ? 5 : 9,
                    receiver: state?.item?.member?.id,
                    poolShip: state?.item?.id,
                    trustState: state.trustState,
                    commission: Number(data.commission),
                    source: 'hwt',
                },
            ])
        }
    }, [payment, moneyPool, data, state, lackOfWallet])
    const { mutate } = useGetMoneyPoolCashin(jsonData)

    useEffect(() => {
        if (data && payment) {
            if (isWallet) {
                if (Number(walletData?.wallet_balance) >= Number(payment)) {
                    setLackOfWallet(0)
                }
                if (Number(walletData?.wallet_balance) < Number(payment)) {
                    setLackOfWallet(
                        Number(payment) +
                            Number(data.commission) -
                            Number(walletData?.wallet_balance)
                    )
                }
            } else {
                setLackOfWallet(Number(payment) + Number(data.commission))
            }
        }
    }, [data, payment, isWallet])
    const navigate = useNavigate()
    const { mutateTransactionWallet } = useSetTransactionsWallet(jsonData)

    return (
        <>
            <div className=" h-screen relative">
                <Header title="" />
                <div className="">
                    {data && state && !isLoading ? (
                        <>
                            <div className=" relative">
                                <img
                                    src={HandIcon}
                                    alt="hand"
                                    className=" mx-auto absolute -top-16 z-50 right-32"
                                />

                                <div className={style['StyledReceipt']}>
                                    <div>
                                        <p>واریز به:</p>
                                        <p>همیان</p>
                                        <hr className=" mt-2" />
                                    </div>
                                    <div className=" flex justify-between mt-1">
                                        <p className="">مبلغ:</p>
                                        <div className={classNames('flex')}>
                                            {isOpenPayment ? (
                                                <NumericFormat
                                                    thousandSeparator
                                                    allowNegative={false}
                                                    name="totalObligationManager"
                                                    className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                    value={
                                                        payment
                                                            ? payment
                                                            : undefined
                                                    }
                                                    onValueChange={(values) => {
                                                        const { value } = values

                                                        setPayment(
                                                            Number(value)
                                                        )
                                                    }}
                                                />
                                            ) : (
                                                // <input
                                                //     type="number"
                                                //     min={0}
                                                //     className=" border-1 border-gray-5 rounded-md bg-gray-5 text-center"
                                                //     value={
                                                //         payment
                                                //             ? payment
                                                //             : undefined
                                                //     }
                                                //     onChange={(e) =>
                                                //         setPayment(
                                                //             Number(
                                                //                 e.target.value
                                                //             )
                                                //         )
                                                //     }
                                                // />
                                                <p>
                                                    {payment
                                                        ? Number(
                                                              payment
                                                          ).toLocaleString()
                                                        : state?.item
                                                              ?.unpaid_portion &&
                                                          state?.item?.unpaid_portion.toLocaleString()}{' '}
                                                    تومان
                                                </p>
                                            )}
                                            {isOpenPayment ? (
                                                <p
                                                    onClick={() =>
                                                        setIsOpenPayment(false)
                                                    }
                                                    className=" text-sm text-green-1 mr-2"
                                                >
                                                    اعمال
                                                </p>
                                            ) : (
                                                <img
                                                    src={EditIcon}
                                                    alt="edit"
                                                    className=" w-4 mr-2"
                                                    onClick={() =>
                                                        setIsOpenPayment(true)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">هزینه اشتراک:</p>
                                        <p>
                                            {Number(
                                                data.commission
                                            ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className=""> بابت:</p>
                                        <p>پرداخت حق عضویت</p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">نام صندوق:</p>
                                        <p>{state?.name}</p>
                                    </div>
                                    <div className=" flex justify-between mt-4">
                                        <div className="text-sm">
                                            <p>استفاده از کیف پول:</p>
                                            <p className=" text-text-gray">
                                                {walletData &&
                                                    walletData?.wallet_balance &&
                                                    walletData?.wallet_balance.toLocaleString()}{' '}
                                                تومان
                                            </p>
                                        </div>
                                        <Switch
                                            onChange={() =>
                                                setIsWallet(!isWallet)
                                            }
                                            checked={isWallet}
                                            onColor="#75B844"
                                            onHandleColor="#EAEEF0"
                                            handleDiameter={25}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            height={30}
                                            width={60}
                                            className="react-switch"
                                            id="material-switch"
                                            offColor="#B6BCC8"
                                        />
                                    </div>
                                    <hr className=" my-4" />
                                    <div className=" flex justify-between mt-2">
                                        <p className="">مبلغ قابل پرداخت:</p>
                                        <p>
                                            {isWallet
                                                ? Number(
                                                      lackOfWallet
                                                  ).toLocaleString()
                                                : Number(
                                                      payment + data.commission
                                                  ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                </div>
                                <div className=" w-full items-center text-center my-4">
                                    <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                        <img
                                            src={
                                                data?.gateways &&
                                                data?.gateways[0]?.img_url
                                            }
                                            hidden={!data?.gateways[0]?.is_active}
                                            alt="bank"
                                            className={classNames(
                                                'mx-2 cursor-pointer',
                                                !isSelected.saderat
                                                    ? ' border-1 border-gray-4 rounded-md'
                                                    : 'border-2 border-green-1 rounded-md'
                                            )}
                                            onClick={() =>
                                                setIsSelected({
                                                    saderat: false,
                                                    parsian: true,
                                                })
                                            }
                                        />
                                        <img
                                            src={
                                                data?.gateways &&
                                                data?.gateways[1]?.img_url
                                            }
                                            hidden={!data?.gateways[1]?.is_active}
                                            alt="bank"
                                            className={classNames(
                                                'mx-2 cursor-pointer',
                                                !isSelected.parsian
                                                    ? ' border-1 border-gray-4 rounded-md'
                                                    : 'border-2 border-green-1 rounded-md'
                                            )}
                                            onClick={() =>
                                                setIsSelected({
                                                    saderat: true,
                                                    parsian: false,
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" bottom-10 absolute w-full">
                                <div className=" w-full">
                                    <div
                                        className=" mx-8 rounded-2xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                                        onClick={() => {
                                            if (data) {
                                                if (
                                                    isSelected.saderat ||
                                                    isSelected.parsian
                                                ) {
                                                    if (isWallet) {
                                                        if (lackOfWallet === 0) {
                                                            const payload: ITransactionPayload =
                                                            {
                                                                amount: Number(
                                                                    lackOfWallet
                                                                ),
                                                                ctx_id: Number(
                                                                    state
                                                                        ?.item
                                                                        ?.member
                                                                        ?.id
                                                                ),
                                                                ctx_type:
                                                                    'mbr',
                                                                destination:
                                                                    'hwt',
                                                                gateway:
                                                                    isSelected.saderat
                                                                        ? 5
                                                                        : 9,
                                                                is_group_pay:
                                                                    false,
                                                                payer_name:
                                                                    '',
                                                                receiver:
                                                                    state
                                                                        ?.item
                                                                        ?.member
                                                                        ?.id,
                                                                receiver_name:
                                                                    '',
                                                                source: 'gtw',
                                                                state: '',
                                                                state_time:
                                                                    '',
                                                                transaction_code:
                                                                    '',
                                                            }
                                                        mutateTransactionWallet(
                                                            payload
                                                        )

                                                        } else {
                                                            const payload: IGatewayPaymentPayload =
                                                                {
                                                                    paymentItems: [
                                                                        {
                                                                            itemAmount: Number(payment),
                                                                            itemType: data?.receivers?.[0]?.type,
                                                                            itemId: state?.item?.id,
                                                                            box_id: Number(moneyPool),
                                                                            commission: data?.receivers?.[0]?.commission,
                                                                            description: "پرداخت حق عضویت",
                                                                        }
                                                                    ],
                                                                    gateway: {
                                                                        uniqueCode: 'HAM_IPG',
                                                                    },
                                                                    clientType: 'pwa', 
                                                                    use_wallet: true 
                                                                }                                                                   
                                                            mutate(payload)
                                                        }
                                                    } else {
                                                        const payload: IGatewayPaymentPayload =
                                                            {
                                                                paymentItems: [
                                                                    {
                                                                        itemAmount: Number(payment),
                                                                        itemType: data?.receivers?.[0]?.type,
                                                                        itemId: state?.item?.id,
                                                                        box_id: Number(moneyPool),
                                                                        commission: data?.receivers?.[0]?.commission,
                                                                        description: "پرداخت حق عضویت",
                                                                    }
                                                                ],
                                                                gateway: {
                                                                    uniqueCode: 'HAM_IPG',
                                                                },
                                                                clientType: 'pwa', 
                                                                use_wallet: false 
                                                            }
                                                        mutate(payload)
                                                    }
                                                } else {
                                                    toast.error(
                                                        'نوع درگاه پرداخت را انتخاب کنید'
                                                    )
                                                }
                                            }
                                        }}
                                    >
                                        پرداخت آنلاین
                                    </div>
                                </div>
                                {state?.isManager && (
                                    <div className=" w-full">
                                        <div
                                            className=" mx-8 rounded-2xl border-1 border-green-1  bg-white text-green-1 text-center py-3 my-2 cursor-pointer"
                                            onClick={() => {
                                                if (data) {
                                                    if (
                                                        isSelected.saderat ||
                                                        isSelected.parsian
                                                    ) {
                                                        setIsOpen(true)
                                                    } else {
                                                        toast.error(
                                                            'نوع درگاه پرداخت را انتخاب کنید'
                                                        )
                                                    }
                                                }
                                            }}
                                        >
                                            ثبت پرداخت
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddJustPayForOtherModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
            />
        </>
    )
}
